import React from 'react';
import {BrowserRouter as Router, Switch, Route,Redirect} from 'react-router-dom';
import App from './App';
import LoginRegister from './LoginRegister';
import store from './store';
import {connect} from 'react-redux';
import auth from './lib/auth';

export default class Root extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      user: null
    }
  }

  async componentDidMount(){
    this.setState({
      user: await auth.user(true),
      loading: false
    })
  }

  renderLoading(){
    return (
        <div className="d-flex flex-column align-items-center justify-content-center" style={{
          height: '100vh'
        }}>
          <img src={process.env.PUBLIC_URL + '/img/logo.svg'}
                  alt={process.env.REACT_APP_NAME}/>
          <div>
            <i className="fa fa-spinner fa-spin" style={{fontSize:'2rem',marginTop: '10px'}}></i>
          </div>
        </div>
    )
  }

  render() {
    return this.state.loading ? this.renderLoading() : (
        <Router>
          <Switch>
            <Route exact path="/user/login" render={(props)=>{
              return this.state.user ? <Redirect to="/"/> :
                  <LoginRegister {...props}/>
            }}/>
            <Route path="/" render={(props)=>{
              return this.state.user ? <App  {...props}/> :
                  <Redirect to="/user/login"/>
            }}/>
          </Switch>
        </Router>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Root.js